import { render } from "./BaseInputFile.vue?vue&type=template&id=6c8b14c7"
import script from "./BaseInputFile.vue?vue&type=script&lang=js"
export * from "./BaseInputFile.vue?vue&type=script&lang=js"
script.render = render

export default script